
import Vue from 'vue';

export default Vue.extend({
  props: {
    imageUrl: {
      type: String,
      required: false,
    },
    hasPhoto: {
      type: Boolean,
      required: false,
    },
    imageAlt: {
      type: String,
      required: true,
    },
    editButtonAlt: {
      type: String,
      required: true,
    },
    editable: {
      type: Boolean,
      default: false,
    },
    isProfileVerified: {
      type: Boolean,
      default: false,
    }
  },
  computed: {
    imageUrl_() {
      return this.imageUrl || '/images/components/profile-avatar-dummy.webp';
    }
  }
});

